export default "__VITE_ASSET__DNPtq9O6__"